import React from 'react';
import { Bert } from 'meteor/themeteorchef:bert';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import {
  // Alert,
  Box,
  Fab,
  // FormControl,
  Grid,
  InputAdornment,
  // InputLabel,
  IconButton,
  // MenuItem,
  Paper,
  // Select,
  styled,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';

// import DownloadIcon from '@mui/icons-material/Download';
import LoadingButton from '@mui/lab/LoadingButton';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import PlagiarismOutlinedIcon from '@mui/icons-material/PlagiarismOutlined';

const FileToolsComponent = ({ MapProps }) => {
  const {
    geojsonFunction,
    serverConnection,
    urlToUpload
  } = MapProps.map.settingsAdvancedMap.fileTools;

  // const allProcess = ['Exportar', 'Subir al servidor'];
  const fileInputRef = React.useRef(null);
  const [importFile, setImportFile] = React.useState(null);
  const [importName, setImportName] = React.useState('');
  const [infoFileInBack, setInfoFileInBack] = React.useState({});
  const [isLoading, setIsLoading] = React.useState(false);
  const [listBackFiles, setListBackFiles] = React.useState([]);
  // const [listProcess, setListProcess] = React.useState([]);
  // const [uidFile, setUidFile] = React.useState('');
  const [uploadFileType, setUploadFileType] = React.useState(true);
  const rowsPerPage = 10;
  // const [selectedProcess, setSelectedProcess] = React.useState(allProcess[0]);
  const [tablePage, setTablePage] = React.useState(0);
  // const [tablePageProcess, setTablePageProcess] = React.useState(0);

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: '#2A3F90',
      color: theme.palette.common.white
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14
    }
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    },
    '&:last-child td, &:last-child th': {
      border: 0
    }
  }));

  const StyledTable = styled(Table)(() => ({
    border: `1px solid #2A3F90`
  }));

  // const generateRandomId = length => {
  //   const valor = Array.from({ length }, () => Math.random().toString(36)[2]).join('');
  //   // setUidFile(valor);
  // };

  const handleChangePage = (event, newPage) => {
    setTablePage(newPage);
  };

  // const handleChangePageProcess = (event, newPage) => {
  //   setTablePageProcess(newPage);
  // };

  // const handleFormatChange = (event, row) => {
  //   const updatedListFiles = listProcess.map(item => {
  //     if (item.name === row.name) {
  //       return {
  //         ...item,
  //         selectedFormat: event.target.value
  //       };
  //     }
  //     return item;
  //   });
  //   setListProcess(updatedListFiles);
  // };

  const loadFileToBack = async () => {
    setIsLoading(true);
    // generateRandomId(10);
    let firstAnswer = {};

    if (!importFile && isEmpty(importFile)) {
      setIsLoading(false);
      Bert.alert('Selecciona un archivo primero', 'danger');
      setImportFile('');
      return;
    }

    const extension = importFile.name.substring(importFile.name.lastIndexOf('.'));

    const updatedFile = new File([importFile], `${importName}${extension}`, {
      type: !isEmpty(importFile.type) ? importFile.type : '',
      lastModified: importFile.lastModified
    });

    const formData = new FormData();
    formData.append('file', updatedFile);
    formData.append('disc', urlToUpload);

    try {
      const response = await fetch('https://sd1.d3.ipsilum.com/upload', {
        method: 'POST',
        body: formData,
        mode: 'cors',
        credentials: 'omit',
        referrerPolicy: 'no-referrer'
      });

      setIsLoading(false);
      firstAnswer = await response.json();
      setInfoFileInBack(firstAnswer.data);
      if (geojsonFunction && geojsonFunction === true) {
        if (firstAnswer.data) {
          try {
            const secondResponse = await fetch(
              `${serverConnection.domain}/MG/htmls/exec_process_geojson`,
              {
                method: 'POST',
                body: JSON.stringify({ data: firstAnswer.data.link }),
                headers: {
                  'Content-Type': 'application/json'
                },
                mode: 'cors',
                credentials: 'omit',
                referrerPolicy: 'no-referrer'
              }
            );
            if (secondResponse.ok) {
              Bert.alert('Archivo subido y ejecutado correctamente', 'success');
            }
          } catch (error) {
            Bert.alert('Archivo subido correctamente pero no ejecutado el proceso', 'error');
          }
        }
      } else {
        Bert.alert('Archivo subido correctamente', 'success');
      }
    } catch (error) {
      console.error('Error:', error);
      setIsLoading(false);
    }
  };

  // const loadTypeProcess = async () => {
  //   try {
  //     const response = await fetch(
  //       'https://sd1.ipsgeoprocesing.ipsilum.com/MG/lidar/exec_process_files',
  //       {
  //         method: 'POST',
  //         headers: { 'Content-Type': 'application/json' },
  //         body: JSON.stringify({
  //           guid: '',
  //           inputFile: '',
  //           execName: 'Request_list',
  //           process_format: ''
  //         }),
  //         mode: 'cors',
  //         credentials: 'omit',
  //         referrerPolicy: 'no-referrer'
  //       }
  //     );
  //     setIsLoading(false);
  //     const answer = await response.json();
  //     const newList = answer.map(file => ({
  //       ...file,
  //       selectedFormat: file.formats[0]
  //     }));
  //     setListProcess(newList);
  //   } catch (error) {
  //     console.error('Error:', error);
  //     setIsLoading(false);
  //   }
  // };

  const callListFiles = async () => {
    try {
      const response = await fetch(
        'https://sd1.ipsgeoprocesing.ipsilum.com/MG/utilities/list_files_folders',
        {
          method: 'POST',
          body: JSON.stringify({
            path: urlToUpload, // url del sitio que quiero listar
            beyond_this_folder: true,
            only_folders: null,
            only_files: true,
            filter_type_file: null
          }),
          headers: { 'Content-Type': 'application/json' }
        }
      );
      const responseJson = await response.json();
      setListBackFiles(responseJson.data);
    } catch (error) {
      Bert.alert('The download entwine for profile has failed', 'danger');
    }
  };

  // const loadProccess = async item => {
  //   const formatSelectedObject = listProcess.find(objeto => objeto.name === item.name);
  //   const formatSelected = formatSelectedObject.selectedFormat;
  //   try {
  //     const response = await fetch(
  //       'https://sd1.ipsgeoprocesing.ipsilum.com/MG/lidar/exec_process_files',
  //       {
  //         method: 'POST',
  //         headers: { 'Content-Type': 'application/json' },
  //         body: JSON.stringify({
  //           guid: uidFile,
  //           inputFile: infoFileInBack.path,
  //           execName: item.value,
  //           process_format: formatSelected
  //         }),
  //         mode: 'cors',
  //         credentials: 'omit',
  //         referrerPolicy: 'no-referrer'
  //       }
  //     );
  //     setIsLoading(false);
  //     const answer = await response.json();
  //     window.open(answer.link, '_blank');
  //   } catch (error) {
  //     console.error('Error:', error);
  //     setIsLoading(false);
  //   }
  // };

  // React.useEffect(() => {
  //   loadTypeProcess();
  // }, []);

  return (
    <Box display="flex" flexDirection="column" gap={2} height="100%" m={2} width="100%">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box
            component="form"
            sx={{
              display: 'flex',
              justifyContent: 'space-evenly',
              width: '100%',
              mb: 2
            }}
            noValidate
            autoComplete="off"
          >
            <Fab
              variant="extended"
              size="small"
              style={{
                color: 'white',
                backgroundColor: '#2A3F90',
                boxShadow: 'none'
              }}
              onClick={() => {
                setUploadFileType(true);
                setImportFile({});
                setInfoFileInBack({});
              }}
            >
              Upload file
            </Fab>
            <Fab
              variant="extended"
              size="small"
              style={{
                color: 'white',
                backgroundColor: '#2A3F90',
                boxShadow: 'none'
              }}
              onClick={() => {
                setUploadFileType(false);
                setImportFile({});
                callListFiles();
                setInfoFileInBack({});
              }}
            >
              Upload files from the server
            </Fab>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          {uploadFileType === true ? (
            <Box
              component="form"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: '100%',
                mb: 2
              }}
              noValidate
              autoComplete="off"
            >
              <TextField
                fullWidth
                label="Nombre del archivo"
                size="small"
                value={importName}
                onChange={event => setImportName(event.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {isLoading && <LoadingButton color="inherit" />}
                      <IconButton
                        aria-label="upload"
                        component="label"
                        style={{ color: '#2A3F90' }}
                        onClick={() => fileInputRef.current.click()}
                      >
                        <PlagiarismOutlinedIcon />
                      </IconButton>
                      <IconButton
                        aria-label="upload"
                        component="label"
                        style={{ color: '#2A3F90' }}
                        onClick={() => loadFileToBack()}
                      >
                        <SaveIcon />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
              <input
                ref={fileInputRef}
                type="file"
                style={{ display: 'none' }}
                onChange={event => {
                  setImportFile(event.target.files[0]);
                  const nameWithoutExtension = event.target.files[0].name.split('.')[0];
                  setImportName(nameWithoutExtension);
                }}
              />
            </Box>
          ) : (
            <Box sx={{ width: '100%' }}>
              <TableContainer component={Paper}>
                <StyledTable aria-label="customized table" size="small" stickyHeader>
                  <TableHead>
                    <TableRow>
                      <StyledTableCell style={{ minWidth: 'fit-content' }} />
                      <StyledTableCell align="left">Server files</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {listBackFiles
                      .slice(tablePage * rowsPerPage, tablePage * rowsPerPage + rowsPerPage)
                      .map(row => (
                        <StyledTableRow key={row.name}>
                          <StyledTableCell>
                            {infoFileInBack.name === row.name ? (
                              <RadioButtonCheckedIcon style={{ color: '#2A3F90' }} />
                            ) : (
                              <RadioButtonUncheckedIcon
                                style={{ color: '#2A3F90' }}
                                onClick={() => setInfoFileInBack(row)}
                              />
                            )}
                          </StyledTableCell>
                          <StyledTableCell>{row.name}</StyledTableCell>
                        </StyledTableRow>
                      ))}
                  </TableBody>
                </StyledTable>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[10]}
                count={listBackFiles.length}
                rowsPerPage={rowsPerPage}
                page={tablePage}
                onPageChange={handleChangePage}
              />
            </Box>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};
export default FileToolsComponent;

FileToolsComponent.defaultProps = {
  MapProps: {}
};
FileToolsComponent.propTypes = {
  MapProps: PropTypes.object
};
